export default __webpack_public_path__ + "cc7d444be8fca4b89f2a66a80569b125.png";